import { Component, inject, type OnInit } from '@angular/core';
import { TaskService } from '../task.service';
import { UtilsService } from '../utils.service';

@Component({
  selector: 'app-bulk-action-button',
  templateUrl: './bulk-action-button.component.html',
  styleUrls: ['./bulk-action-button.component.scss'],
  standalone: false,
})
export class BulkActionButtonComponent implements OnInit {
  public taskService = inject(TaskService);
  private utilsService = inject(UtilsService);

  ctrlOrCmd = '';
  backspaceOrDelete = '';
  visible = false;

  ngOnInit() {
    this.ctrlOrCmd = this.utilsService.ctrlOrCmdText();
    this.backspaceOrDelete = this.utilsService.backspaceOrDeleteText();

    this.taskService.selectionsSubject.subscribe((s) => {
      this.visible = s.length > 1;
    });
  }
}
